import Button from 'components/Form/Button';
import Input from 'components/Form/Input';
import ContainerUnauthenticated from 'containers/Unauthenticated';
import { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DoForgotPassword } from 'services/authentication';
import { ButtonContainer, FormTitle } from 'ui/styled';
import { exposeStrapiError } from 'utils';
import { FormText, RegisterContent } from './styled';

export default function Forgot() {
  const history = useHistory();
  const navigate = (to) => history.push(`/${to}`);
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({});
  const formValue = (ref) => {
    return form?.[ref] ? form?.[ref] : '';
  };
  const changeForm = (value, ref) => {
    setForm({ ...form, [ref]: value });
  };
  const valid = (verbose = false) => {
    if (!formValue('email') || !formValue('email').length) {
      if (verbose) {
        toast.error('Preencha o campo: Email');
      }
      return false;
    }
    return true;
  };
  const action = async () => {
    if (!valid(true)) {
      return;
    }
    setLoading(true);
    const result = await DoForgotPassword({
      email: formValue('email')?.replace(/ /g, ''),
    });
    setLoading(false);
    if (result && !exposeStrapiError(result)) {
      completNext();
    }
  };
  const completNext = () => {
    toast.success(
      'Instruções para recuperar senha foram enviadas ao seu email'
    );
    navigate('login');
  };
  const steps = useMemo(() => {
    return [
      {
        title: 'Esqueceu a senha?',
        text: 'Digite seu e-mail cadastrado para recuperar sua senha de acesso',
        button1: 'Cancel',
        button2: 'Enviar e-mail de recuperação',
      },
      {
        title: 'Verifique seu e-mail',
        text: 'Acesse o link de recuperação que foi enviado no seu email cadastrado',
        button2: 'Voltar para o login',
      },
    ];
  }, []);

  const next = () => {
    if (step === steps.length - 1) {
      navigate('login');
      return;
    }
    setStep(step + 1);
    action();
  };
  const back = () => {
    if (step === 0) {
      navigate('login');
      return;
    }
    setStep(step - 1);
  };

  return (
    <>
      <ContainerUnauthenticated>
        <RegisterContent>
          <FormTitle>{steps?.[step]?.title}</FormTitle>
          <FormText>{steps?.[step]?.text}</FormText>
          {step !== 0 ? null : (
            <Input
              placeholder="Email"
              id={'email'}
              value={formValue('email')}
              onChange={(e) => changeForm(e.target.value, 'email')}
            />
          )}
          <ButtonContainer space start>
            {step !== 0 ? null : (
              <Button
                color="lightgrey"
                border
                width={'fit-content'}
                loading={loading}
                onClick={back}
              >
                {steps?.[step]?.button1}
              </Button>
            )}
            <Button color="blue" onClick={next} width={'fit-content'}>
              {steps?.[step]?.button2}
            </Button>
          </ButtonContainer>
        </RegisterContent>
      </ContainerUnauthenticated>
    </>
  );
}
